import { useEffect, useState } from 'react';

import { getPaymentSimulate } from '@/services/api';
import { useParams } from 'react-router-dom';
import { useAsyncFn } from 'react-use';

import { ILinkSimulateProps } from '@/pages/Checkout/types/paymentLinkContextTypes';

const usePaymentSimulate = () => {
  const { id } = useParams();

  const [getSimulationIsLoading, setSimulationIsLoading] =
    useState<boolean>(true);
  const [getSimulationData, setSimulationData] =
    useState<ILinkSimulateProps | null>(null);

  const [paymentLinkData, paymentLinkRequest] = useAsyncFn(getPaymentSimulate);

  useEffect(() => {
    paymentLinkRequest(id && id.split(' ')[0]);
  }, []);

  useEffect(() => {
    if (paymentLinkData.loading) return;

    if (paymentLinkData.value?.data) {
      setSimulationData(paymentLinkData.value?.data);
      setSimulationIsLoading(false);
    }
  }, [paymentLinkData]);

  return {
    getSimulationIsLoading,
    getSimulationData,
    getSimulationError: paymentLinkData.error,
  };
};

export default usePaymentSimulate;
